export const version = "ethers/5.7.0";
